export default __webpack_public_path__ + "36638814ff3da6438b4f7cc5a8b5c670.png";